import React from "react";
const SearchContentBlock = (props) => {
    return (React.createElement("div", { className: "searchblock-generic-block d-flex justify-content-between align-items-start gap-20", onClick: () => {
            !props.edit && props.onSelected && props.onSelected();
        } },
        React.createElement("div", null,
            React.createElement("div", null, props.topleft),
            props.bottomleft && React.createElement("div", { className: "mgt-5" }, props.bottomleft)),
        props.edit ? (props.editAction) : (React.createElement("div", { className: "taRight" },
            React.createElement("div", { className: " DMSansNormal_12_400 txt-midnight-blue" }, props.topright),
            props.bottomRight && (React.createElement("div", { className: "mgt-5 d-center-end" }, props.bottomRight))))));
};
export default SearchContentBlock;
